













import { defineComponent, ComponentRenderProxy, ref, getCurrentInstance, inject, watch } from '@vue/composition-api';
import { CaretUpSmallIcon, CaretDownSmallIcon } from 'tdesign-icons-vue';
const dispatch = (cxt: ComponentRenderProxy, componentName: any, eventName: string, params: unknown) => {
  let parent = cxt.$parent || cxt.$root;
  let { name } = parent.$options;
  while (parent && (!name || name !== componentName)) {
    parent = parent.$parent;
    if (parent) {
      name = parent.$options.name || '';
    }
  }
  if (parent) {
    parent.$emit(eventName, params);
  }
};
export default defineComponent({
  components: {
    CaretUpSmallIcon,
    CaretDownSmallIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    // collapse-item的唯一标识
    name: {
      type: [String, Number],
      required: true,
    },
  },
  setup(props, context) {
    const collapse: any = inject('collapse');
    const currComponent: any = getCurrentInstance();
    const isActive = ref(collapse.activeNames.indexOf(props.name) > -1);
    const methods = {
      handleHeaderClick() {
        dispatch(currComponent.proxy, 'collapse', 'menu-item-click', props.name);
      },
    };
    watch(
      () => collapse.activeNames,
      val => {
        // if (val[0] === props.name) {
        //   isActive.value = !isActive.value;
        // } else {
        //   isActive.value = collapse.activeNames.indexOf(props.name) > -1;
        // }
        isActive.value = collapse.activeNames.indexOf(props.name) > -1;
      },
    );
    return {
      isActive,
      ...methods,
    };
  },
});
